import script from "./OrderDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./OrderDetailModal.vue?vue&type=style&index=0&id=5545f760&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5545f760"]])

export default __exports__